import Customer from '@/models/Customer'
import Restaurant from '@/models/Restaurant'
import OrderItem from '@/models/OrderItem'
import Address from './Address'
import PaymentMethod from './PaymentMethod'

export default class Order {
    uid = 0
    serialNumber = 0
    crdate = 0
    date = new Date()
    status = OrderStatus.Undefined
    transport = ""
    payment_complete = 0
    payment_method = new PaymentMethod()
    restaurant = new Restaurant()
    customer = new Customer()
    address = new Address()
    items: OrderItem[] = []
    pickup_date = ""
    pickup_time = ""
    preorder_date = ""
    preorder_time = ""
    estimate_complete = ""
    total = 0
    new_customer = 0
    receipt_printed = 0
    real_delivery_costs = 0
    preorder = 0
    comment = ""

    static orderStatusText(status: OrderStatus): string {
        switch (status) {
            case OrderStatus.Pending: return "Offen"
            case OrderStatus.InProgress: return "in Vorbereitung"
            case OrderStatus.Closed: return "Erledigt"
            case OrderStatus.Cancelled: return "Storniert"
            default: return "(Unbekannt)"
        }
    }

    static paymentStatusText(status: number): string {
        switch (status) {
            case 0: return "Offen"
            case 1: return "Bezahlt"
            default: return "(Unbekannt)"
        }
    }

    static orderStatusColor(status: OrderStatus): string {
        switch (status) {
            case OrderStatus.Pending: return "#BA3314"
            case OrderStatus.InProgress: return "#E6D300"
            case OrderStatus.Closed: return "#000000"
            case OrderStatus.Cancelled: return "Storniert"
            default: return "#CCCCCC"
        }
    }
}

export enum OrderStatus {
    Undefined = 0,
    Pending = 1,
    InProgress = 2,
    Closed = 3,
    Cancelled = 4
}
